"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreuiSidebarDropdown = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
/* eslint-disable jsx-a11y/anchor-is-valid */
const CoreuiSidebarDropdownComponent = (props) => {
    const { icon, text, clickHandler, children, url } = props;
    const isActive = window.location.pathname.includes(url);
    return (react_1.default.createElement("li", { className: `nav-item nav-dropdown ${isActive ? 'open' : ''}` },
        react_1.default.createElement("a", { className: "nav-link nav-dropdown-toggle", href: "#", onClick: clickHandler },
            react_1.default.createElement("i", { className: icon }),
            ` ${text}`),
        react_1.default.createElement("ul", { className: "nav-dropdown-items" }, children)));
};
CoreuiSidebarDropdownComponent.propTypes = {
    children: prop_types_1.default.node.isRequired,
    url: prop_types_1.default.string.isRequired,
    text: prop_types_1.default.string.isRequired,
    clickHandler: prop_types_1.default.func.isRequired,
    icon: prop_types_1.default.string,
};
CoreuiSidebarDropdownComponent.defaultProps = {
    icon: '',
};
exports.CoreuiSidebarDropdown = CoreuiSidebarDropdownComponent;
//# sourceMappingURL=CoreuiSidebarDropdown.js.map